var map = {
	"./bird.jpg": 42627,
	"./boy 01.jpg": 54525,
	"./boy.jpg": 23866,
	"./deer 1.jpg": 31543,
	"./doll.jpg": 29025,
	"./duck.jpg": 37609,
	"./elephant.jpg": 90665,
	"./flowers.jpg": 37968,
	"./honey bee.jpg": 67201,
	"./lion.jpg": 73736,
	"./penguin.jpg": 7328,
	"./rab.jpg": 48087,
	"./rabbit 1.jpg": 30839,
	"./rabbit 2.jpg": 3560,
	"./rat.jpg": 92185,
	"./zerafee.jpg": 19460
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 68052;